import React from "react";

import {
Card,
CardBody,
} from "reactstrap";

import {
FaRocket,
} from "react-icons/fa";

const ComingSoonPage = () => {

return (

    <div
        style={{
            minHeight:
                "100vh",

            display:
                "flex",

            alignItems:
                "center",

            justifyContent:
                "center",

            background:
                "#f5f7fb",

            padding:
                "30px 15px",
        }}
    >

        <style>
            {`

                @keyframes comingSoonFloat {

                    0% {
                        transform: translateY(0px);
                    }

                    50% {
                        transform: translateY(-12px);
                    }

                    100% {
                        transform: translateY(0px);
                    }

                }

                .coming-soon-icon {

                    animation:
                        comingSoonFloat
                        2s
                        ease-in-out
                        infinite;

                }

            `}
        </style>


        <Card
            className="border-0 shadow-sm"
            style={{
                width:
                    "100%",

                maxWidth:
                    "520px",

                borderRadius:
                    "20px",
            }}
        >

            <CardBody
                className="text-center p-5"
            >

                {/* Animated Icon */}

                <div
                    className="coming-soon-icon mb-4"
                >

                    <div
                        style={{
                            width:
                                "90px",

                            height:
                                "90px",

                            margin:
                                "0 auto",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "center",

                            borderRadius:
                                "50%",

                            background:
                                "#eef3ff",

                            fontSize:
                                "38px",

                            color:
                                "#405189",
                        }}
                    >

                        <FaRocket />

                    </div>

                </div>


                {/* Heading */}

                <h2
                    className="mb-3 fw-bold"
                >

                    Coming Soon

                </h2>


                {/* Description */}

                <p
                    className="text-muted mb-0"
                    style={{
                        fontSize:
                            "16px",

                        lineHeight:
                            "1.7",
                    }}
                >

                    We're working on something exciting.
                    This feature is currently under development
                    and will be available soon.

                </p>

            </CardBody>

        </Card>

    </div>

);

};

export default ComingSoonPage;
